import { IActionContext } from '../helpers/ActionContext';
import { CommonErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IDataAlertBase, IDataAlertInfo } from '../models/IDataAlertInfo';
import { IErrorItem } from '../models/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { DataAlerts } from '../resources/DataAlerts';
import { IResult } from '../ServerApi/types/IResponse';
import { ActionHelpers } from './ActionHelpers';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { IErrorDetail } from './ContentActionNotification';

export class DeleteDataAlertsAction {

  public static $inject = [
    'ActionHelpers',
    'ConfirmActionDialog',
    'DataAlerts',
    '$translate',
  ];

  constructor(
    private ActionHelpers: ActionHelpers,
    private ConfirmActionDialog: ConfirmActionDialog,
    private DataAlerts: DataAlerts,
    private $translate: ng.translate.ITranslateService) { }

  public deleteDataAlerts(alerts: Set<IDataAlertInfo>, context: IActionContext): ng.IPromise<IResult> {

    const recipientCount = alerts.sum(a => a.recipientsCount);

    let dialogBodyText: string;
    if (alerts.size() === 1) {
      dialogBodyText = this.$translate.instant('confirmDeleteDataAlert', {
        ALERT_NAME: L10n.elideIfLong(alerts.first().name),
        RECIPIENT_COUNT: recipientCount
      }, L10n.Interpolations.Count);
    } else {
      dialogBodyText = this.$translate.instant('confirmDeleteDataAlerts', {
        ALERT_COUNT: alerts.size(),
        RECIPIENT_COUNT: recipientCount
      }, L10n.Interpolations.Count);
    }

    return this.ConfirmActionDialog.open({
      scope: context.scope,
      title: this.$translate.instant('deleteMessage'),
      bodyText: dialogBodyText,
      actionName: this.$translate.instant('confirmDeleteButton', { ITEM_COUNT: alerts.size() }, L10n.Interpolations.Count),
      isDeleteAction: true,
      action: () => this.DataAlerts.del(alerts.keys()).then(result => this.notifyResult(alerts, result))
    }).result;
  }

  private notifyResult(alerts: Set<IDataAlertInfo>, result: IResult) {
    this.ActionHelpers.notifyStandardError(
      alerts,
      {
        successId: 'deleteDataAlertsSuccess',
        errorId: 'deleteDataAlertsError'
      },
      (errorItem: IErrorItem<IDataAlertInfo>) => this.errorDetailFor(errorItem)
    )(result);
  }

  public errorDetailFor(errorItem: IErrorItem<IDataAlertBase>): IErrorDetail {
    const itemName = errorItem.item.name;
    let errorMessage: string;

    switch (errorItem.error.code) {
      case CommonErrorCode.DataAlertNotFound:
        errorMessage = this.$translate.instant('errorDataAlertNotFound', { ALERT_NAME: L10n.elideIfLong(itemName) });
        break;
      default:
        errorMessage = this.$translate.instant('errorUnknown');
    }

    return { itemName, errorMessage };
  }

}

Module.instance().service('DeleteDataAlertsAction', DeleteDataAlertsAction);
